// Dummy data for subjects and videos
export const subjectsData = [
  {
    id: 1,
    name: "JavaScript Fundamentals",
    icon: "💻",
    description: "Master the basics of JavaScript programming",
    videos: [
      {
        id: 101,
        title: "Introduction to JavaScript",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        duration: 60
      },
      {
        id: 102,
        title: "Variables and Data Types",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
        duration: 120
      },
      {
        id: 103,
        title: "Functions and Scope",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        duration: 90
      }
    ]
  },
  {
    id: 2,
    name: "React Essentials",
    icon: "⚛️",
    description: "Build modern web apps with React",
    videos: [
      {
        id: 201,
        title: "Getting Started with React",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
        duration: 100
      },
      {
        id: 202,
        title: "Components and Props",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
        duration: 85
      },
      {
        id: 203,
        title: "State and Hooks",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
        duration: 110
      }
    ]
  },
  {
    id: 3,
    name: "CSS & Styling",
    icon: "🎨",
    description: "Create beautiful and responsive designs",
    videos: [
      {
        id: 301,
        title: "CSS Basics",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
        duration: 75
      },
      {
        id: 302,
        title: "Flexbox and Grid",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
        duration: 95
      },
      {
        id: 303,
        title: "Responsive Design",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4",
        duration: 80
      }
    ]
  },
  {
    id: 4,
    name: "Node.js Backend",
    icon: "🟢",
    description: "Build server-side applications with Node.js",
    videos: [
      {
        id: 401,
        title: "Node.js Introduction",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
        duration: 70
      },
      {
        id: 402,
        title: "Express Framework",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4",
        duration: 105
      }
    ]
  },
  {
    id: 5,
    name: "Database Design",
    icon: "🗄️",
    description: "Learn SQL and database management",
    videos: [
      {
        id: 501,
        title: "SQL Fundamentals",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4",
        duration: 90
      },
      {
        id: 502,
        title: "Database Relationships",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4",
        duration: 100
      }
    ]
  },
  {
    id: 6,
    name: "Web Security",
    icon: "🔒",
    description: "Secure your web applications",
    videos: [
      {
        id: 601,
        title: "Authentication Basics",
        url: "https://www.w3schools.com/html/mov_bbb.mp4",
        duration: 85
      },
      {
        id: 602,
        title: "JWT and OAuth",
        url: "https://www.w3schools.com/html/movie.mp4",
        duration: 95
      }
    ]
  }
];
